// extracted by mini-css-extract-plugin
module.exports = {"text":"enrolled-people_text__1NDhG","container":"enrolled-people_container__1Dq4O"};